export default __webpack_public_path__ + "static/media/pro-elevate-cbb-1.551b7451.png";